import React, { useEffect, useRef } from "react";

// ===================================================================
// The Crowd v2 — Modale
//
// Fenetre de dialogue generique : fond assombri, titre, contenu,
// actions. Echap ou clic sur le fond ferment la modale (sauf pendant
// une operation en cours, via `bloquee`). Styles dans v2-composants.css.
//
// Props : titre, onClose, bloquee, actions (noeud), children
// ===================================================================

function ModaleV2({ titre, onClose, bloquee = false, actions, children }) {
  const dialogueRef = useRef(null);

  useEffect(() => {
    dialogueRef.current?.focus();
  }, []);

  const fermer = () => {
    if (!bloquee) onClose();
  };

  return (
    <div
      className="v2-modale-fond"
      onMouseDown={(e) => { if (e.target === e.currentTarget) fermer(); }}
      onKeyDown={(e) => { if (e.key === "Escape") fermer(); }}
    >
      <div className="v2-modale" role="dialog" aria-modal="true" aria-label={titre} tabIndex={-1} ref={dialogueRef}>
        <h2 className="v2-modale-titre">{titre}</h2>
        <div className="v2-modale-corps">{children}</div>
        {actions && <div className="v2-actions">{actions}</div>}
      </div>
    </div>
  );
}

export default ModaleV2;
